import { render, staticRenderFns } from "./wechat-bind.vue?vue&type=template&id=8958dd88&scoped=true&"
import script from "./wechat-bind.vue?vue&type=script&lang=js&"
export * from "./wechat-bind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8958dd88",
  null
  
)

export default component.exports